import React from "react";
import { Accordion, AccordionContent } from "../../../../components/accordion";
import { t } from "../../../../core/translate";
import { StyledAccordionButton, StyledCaret, ThemedList } from "./styles";
import { HelpIcon } from "./styles";
import { support, privacy, terms, about, feedback } from "../menu-items/help";

export default ({ headingLevel }) => {
  const data = [
    {
      listItems: [support(), privacy(), terms(), about(), feedback()].filter(
        el => !!el
      )
    }
  ];
  return (
    <Accordion>
      <StyledAccordionButton level={headingLevel}>
        <HelpIcon color="white" />
        {t("base.help", "Help")}
        <StyledCaret />
      </StyledAccordionButton>
      <AccordionContent>
        <ThemedList data={data} />
      </AccordionContent>
    </Accordion>
  );
};
